
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_172_2262)","fill":"#3E9F3C"}},[_c('path',{attrs:{"d":"M15.83 9.992a.833.833 0 00-.832.833v6.672c0 .46-.374.834-.833.834H2.5a.834.834 0 01-.833-.834V5.822c0-.46.373-.834.833-.834h6.665a.833.833 0 000-1.668H2.5A2.503 2.503 0 000 5.822v11.675a2.503 2.503 0 002.5 2.502h11.665c1.378 0 2.5-1.123 2.5-2.502v-6.672a.833.833 0 00-.834-.833zM19.03 3.695l.517-.526c.634-.634.59-1.704-.044-2.338L19.17.5c-.633-.634-1.702-.68-2.336-.045L16.31.97l2.722 2.725z"}}),_c('path',{attrs:{"d":"M7.494 9.811l-.022.023-1.631 4.195c-.04.103.063.206.17.17l4.183-1.641 8.427-8.434-2.727-2.73-8.405 8.413.005.005zm-.72 2.59l.827-2.113c.027.108.081.207.162.287a.662.662 0 00.548.18l.12-.013-.012.121a.685.685 0 00.184.553c.14.14.328.202.548.18l.121-.013-.013.12c-.023.212.04.41.18.55a.67.67 0 00.314.17l-2.125.832-.853-.854zm9.398-8.722l.122.12L9.9 10.199l-.12-.121 6.391-6.398z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_172_2262"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    